import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import AvailableFields from './AvailableFields';
import DragDropHelpers, { replaceFieldsInHtml } from './DragDropHelpers';
import { DateTime2TextConverter, dateTime2TextConverterController } from './Converters/DateTime2TextConverter';
import Number2TextConverter from './Converters/Number2TextConverter';

class TextInput extends Component {

    state = {
        value: undefined,
        fieldsVisible: false,
        initialized: false
    }

    constructor() {
        super()
        this.onChange = this.onChange.bind(this)
        this.openConverter = this.openConverter.bind(this)
        this.onFieldParamsUpdated = this.onFieldParamsUpdated.bind(this)

        this.myRef = React.createRef()
        this.addFieldRef = React.createRef()
    }

    componentDidMount() {
        this.componentDidUpdate()

        this.timeout = null
    }

    componentDidUpdate() {
        if (this.props.inputTypes && this.props.inputTypes.length > 0 && !this.dragDropHelpers && this.myRef) {
            this.dragDropHelpers = new DragDropHelpers(this.props.inputTypes, this.onChange, this.myRef, this.addFieldRef, true, undefined, undefined, this.openConverter, this.textConvert)

            if (this.props.value) {
                this.dragDropHelpers.readValueAndInitializeComponents(this.props.value)
            }
            this.myRef.current.addEventListener("drop", this.dragDropHelpers.drop)
            this.myRef.current.addEventListener("dragover", this.dragDropHelpers.dragOver)
            this.setState({ initialized: false })
        } else {
            if (this.myRef && this.myRef.current && !this.timeout && !this.state.initialized
                && this.props.value && this.myRef.current.innerHTML != this.props.value && !this.props.value.includes("{{")) {
                this.myRef.current.innerHTML = this.props.value
                this.setState({ initialized: true })
            }
        }
    }

    onChange = () => {
        var html = this.myRef.current.innerHTML
        if (html !== this.lastHtml) {
            if (this.dragDropHelpers) {
                html = replaceFieldsInHtml(html)
            }

            if (!this.props.keepHtml) {
                //Removing the html tags and convert the escaped characters
                var el = document.createElement("div");
                el.innerHTML = html;
                html = el.textContent;
            }

            clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.props.onChange(html)
            }, 600);
        }
        this.lastHtml = html
    }

    openConverter = (e) => {
        this.setState({ fieldToConvert: e.target })
    }

    textConvert = (field) => {
        var converterText = dateTime2TextConverterController.convertText(field)
        if (!converterText) {
            converterText = "click to format"
        }

        var indexOfConverter = field.value.indexOf('(')
        if (indexOfConverter > 0) {
            field.value = field.value.substring(0, indexOfConverter - 1)
        }
        field.value += ' (' + converterText + ')'
    }

    onFieldParamsUpdated = (params) => {
        this.state.fieldToConvert.dataset.params = btoa(unescape(encodeURIComponent(JSON.stringify(params))))
        this.onChange()
    }

    render() {
        const { t } = this.props;

        let className = "form-control"
        if (this.props.required && (!this.lastHtml || this.lastHtml.trim() === "")) {
            className += " invalid"
        }

        //If we want to be one line only: onKeyDown={(e) => { if (e.keyCode === 13) { e.preventDefault(); } }}
        return <>
            <DateTime2TextConverter
                title={t("lbl_convert_to_text")}
                buttonText={t("btn_done")}
                field={this.state.fieldToConvert}
                onParamsUpdated={this.onFieldParamsUpdated}
                onHide={() => { this.textConvert(this.state.fieldToConvert); this.setState({ fieldToConvert: undefined }) }} />
            <Number2TextConverter
                title={t("lbl_convert_to_text")}
                buttonText={t("btn_done")}
                field={this.state.fieldToConvert}
                onParamsUpdated={this.onFieldParamsUpdated}
                onHide={() => this.setState({ fieldToConvert: undefined })} />
            <div className="d-flex"><div type="text"
                className={className}
                contentEditable="true"
                onBlur={this.onChange}
                onInput={this.onChange}
                ref={this.myRef}
            />
                {this.props.inputTypes && this.props.inputTypes.length > 0 ? <>
                    <button
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="icon-button field-add-button"
                        title={t("tip_field_add")}
                    ><i className="fas fa-plus"></i></button>

                    <div className="dropdown-menu field-selector" aria-labelledby="dropdownMenuLink" ref={this.addFieldRef} >
                        {this.dragDropHelpers ? <AvailableFields types={this.props.inputTypes} onFieldClick={this.dragDropHelpers.addField} /> : ""}
                    </div>
                </>
                    : ""}
            </div>
        </>
    }
}

export default withTranslation()(TextInput)